if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				const quantityError = item.querySelector('[data-quantity-error]');

				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						let baseItemQuantity = parseInt(qty.getAttribute('data-quantity-base'));
						let currentItemQuantity = parseInt(qty.getAttribute('data-current-quantity'));

						if (parseInt(qty.value) % baseItemQuantity != 0) {
							qty.value = currentItemQuantity;
							quantityError.style.display = 'block';
							setTimeout(()=>{
								quantityError.style.display = 'none';
							}, 3000);
						} else {
							e.preventDefault();
							e.target.blur();
							this.updateCartQty(item, parseInt(qty.value));
							quantityError.style.display = 'none';
						}
					}, 1200));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		async updateCartQty(item, newQty) {
			try {
				this.form.classList.add('processing');
				if (this.querySelector('.alert')) {
					this.querySelector('.alert').remove();
				}

				const productHandle = item.dataset.productHandle;
				const currentVariantId = parseInt(item.dataset.variantId);

				// Get current cart to find the current item's selling plan
				const cartResponse = await fetch('/cart.js');
				const cartData = await cartResponse.json();
				
				// Find the current item in the cart
				const currentCartItem = cartData.items.find(cartItem => 
					cartItem.variant_id === currentVariantId
				);

				// Store the current selling plan and properties
				const currentSellingPlan = currentCartItem?.selling_plan_allocation?.selling_plan?.id;
				const currentProperties = currentCartItem?.properties || {};

				// Fetch product data
				const productResponse = await fetch(`/products/${productHandle}.json`);
				const productData = await productResponse.json();
				const variants = productData.product.variants;
				
				const extractQuantity = (title) => {
					const match = title.match(/\d+/);
					return match ? parseInt(match[0]) : 0;
				};

				// Sort variants by quantity in descending order
				const sortedVariants = [...variants].sort((a, b) => 
					extractQuantity(b.title) - extractQuantity(a.title)
				);

				// Find the appropriate variant based on quantity
				let matchingVariant = null;
				for (const variant of sortedVariants) {
					const variantQty = extractQuantity(variant.title);
					if (variantQty <= newQty) {
						matchingVariant = variant;
						break;
					}
				}

				// If no matching variant found, use the smallest quantity variant
				if (!matchingVariant && sortedVariants.length > 0) {
					matchingVariant = sortedVariants[sortedVariants.length - 1];
				}

				// Check if we need to change variants
				const needsVariantChange = matchingVariant && currentVariantId !== matchingVariant.id;

				if (needsVariantChange) {
					// First add the new variant
					const addResponse = await fetch('/cart/add.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							id: matchingVariant.id,
							quantity: newQty,
							selling_plan: currentSellingPlan || '',
							properties: currentProperties
						})
					});

					// Get updated cart to find the old variant's current line number
					const updatedCartResponse = await fetch('/cart.js');
					const updatedCartData = await updatedCartResponse.json();
					
					// Find the line number of the old variant
					const oldVariantLine = updatedCartData.items.findIndex(cartItem => 
						cartItem.variant_id === currentVariantId
					) + 1;

					// Then remove the old variant
					if (oldVariantLine > 0) {
						const removeResponse = await fetch(KROWN.settings.routes.cart_change_url, {
							method: 'POST',
							headers: { 
								'Content-Type': 'application/json', 
								'Accept': 'application/javascript' 
							},
							body: JSON.stringify({
								line: oldVariantLine,
								quantity: 0
							})
						});
					}

				} else {
					// Just update quantity if no variant change needed
					const response = await fetch(KROWN.settings.routes.cart_change_url, {
						method: 'POST',
						headers: { 
							'Content-Type': 'application/json', 
							'Accept': 'application/javascript' 
						},
						body: JSON.stringify({
							line: parseInt(item.dataset.line),
							quantity: newQty,
							selling_plan: currentSellingPlan || '',
							properties: currentProperties
						})
					});

					const responseData = await response.json();
					if (responseData.status == 422) {
						const alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						alert.innerHTML = typeof responseData.description === 'string' 
							? responseData.description 
							: responseData.message;
						this.form.prepend(alert);
					}
				}

				// Fetch updated cart section
				const cartResponse2 = await fetch('?section_id=helper-cart');
				const text = await cartResponse2.text();

				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();

				document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
					elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
				});
				document.querySelectorAll('[data-header-cart-total').forEach(elm => {
					elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
				});

				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
						
				const event = new Event('cart-updated');
				this.dispatchEvent(event);

			} catch (e) {
				console.log('Error:', e);
				const alert = document.createElement('span');
				alert.classList.add('alert', 'alert--error');
				alert.textContent = KROWN.settings.locales.cart_general_error;
				this.form.prepend(alert);

			} finally {
				this.form.classList.remove('processing');
			}
		}

	}


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			// this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			// this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}